// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","transcriptionContent":"wcjUT","transcriptionText":"_1yWwi","container":"vZNak","button":"_2G9dT","arrow":"_1z9YE"};